import React, { useState } from 'react';
import { Box, LinearProgress, Snackbar, IconButton, Badge, Tabs, Tab, Chip } from '@material-ui/core';
import { useMediaQuery } from 'react-responsive';
import { Alert } from '@material-ui/lab';

import useStyles from './styles/PremiumBacklink.style';
import MobileTitle from '../../customUI/MobileTitle';
import OrderModal from './components/OrderModal';
import TermsModal from './components/TermsModal';
import usePremiumBacklink from './hooks/usePremiumBacklink';
import useLoadPremiumBacklink from './hooks/useLoadPremiumBacklink';
import PremiumBacklinksTable from './components/PremiumBacklinksTable';
import OrdersInProcessTable from './components/OrdersInProcessTable';

const PremiumBacklink = () => {
  const classes = useStyles();
  const isPhone = useMediaQuery({ query: '(max-width: 768px)' });
  const [activeTab, setActiveTab] = useState(0);

  // Load data and effects
  useLoadPremiumBacklink();

  // Get utility functions and data from hook
  const {
    cart,
    snackbarOpen,
    snackbarMessage,
    customToastOpen,
    customToastMessage,
    isFetching,
    openModal,
    handleCloseSnackbar,
    handleCloseCustomToast,
    calculateCartCount,
    ordersInProgressCount,
  } = usePremiumBacklink();


  // Calculate cart values
  const cartCount = calculateCartCount(cart);

  // Handle tab change
  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  if (isFetching) {
    return (
      <LinearProgress
        style={{ width: '100%' }}
        classes={{
          colorPrimary: classes.colorPrimary,
          barColorPrimary: classes.barColorPrimary,
        }}
      />
    );
  }

  return (
    <>
      {isPhone && <MobileTitle title="Premium Backlinks" />}
      <OrderModal />
      <TermsModal />
      <div className={classes.wrapper}>
        <div className={classes.lead__flex}>
          <Box display='flex' flex={1} flexDirection='column'>


            {/* Tab Navigation */}
            <Box mb={3} display="flex" justifyContent="space-between" flexWrap="wrap">
              <Tabs
                value={activeTab}
                onChange={handleTabChange}
                indicatorColor="primary"
                textColor="primary"
                className={classes.tabs}
                variant={isPhone ? "scrollable" : "standard"}
                scrollButtons={isPhone ? "auto" : "off"}
              >
                <Tab label="Premium Backlinks" />
                <Tab
                  label={
                    <Box display="flex" alignItems="center" gap={1}>
                      {isPhone ? "Orders" : "Orders in Progress"}
                       {(ordersInProgressCount > 0) && (
                       <Chip
                         label={ordersInProgressCount}
                         size="small"
                         color="primary"
                         style={{
                           height: '20px',
                           fontSize: '0.75rem',
                           fontWeight: 600,
                           marginLeft: '5px',
                           color: 'white'
                         }}
                       />
                       )}
                    </Box>
                  }
                />
              </Tabs>
              <Box display='flex' justifyContent='flex-end' alignItems='center' mb={2}>
                {/* <Typography variant="h6" component="h2">Premium Backlinks</Typography> */}
                <Box display='flex' alignItems='center' gap={1}>
                  {/* Custom Toast */}
                  {customToastOpen && (
                    <div
                      className={classes.customToast}
                      style={{
                        backgroundColor: '#dff0d8',
                        border: '1px solid #d6e9c6',
                        borderRadius: '4px',
                        padding: '8px 12px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                        maxWidth: '300px'
                      }}
                    >
                      <svg className={classes.toastIcon} width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M3.91943 0.287111C4.05127 0.108399 4.26221 0 4.48486 0H11.5161C11.7388 0 11.9497 0.105469 12.0816 0.287111L15.3628 4.74026C15.5621 5.00979 15.5416 5.38186 15.3189 5.63089L8.52199 13.1309C8.39016 13.2774 8.19973 13.3624 8.00051 13.3624C7.80129 13.3624 7.61379 13.2774 7.47902 13.1309L0.68211 5.63089C0.456523 5.38186 0.438945 5.00979 0.638165 4.74026L3.91943 0.287111ZM5.04737 1.45313C4.95069 1.52637 4.92432 1.65821 4.98584 1.76075L6.66749 4.56155L2.35497 4.9219C2.23485 4.93069 2.1411 5.03323 2.1411 5.15628C2.1411 5.27932 2.23485 5.37893 2.35497 5.39065L7.98 5.8594C7.99172 5.8594 8.00637 5.8594 8.01808 5.8594L13.6431 5.39065C13.7632 5.38186 13.857 5.27932 13.857 5.15628C13.857 5.03323 13.7632 4.93362 13.6431 4.9219L9.33352 4.56448L11.0152 1.76368C11.0767 1.66114 11.0503 1.52637 10.9536 1.45606C10.857 1.38575 10.7222 1.39747 10.6402 1.48536L8.00051 4.34182L5.36084 1.48243C5.27881 1.39454 5.14405 1.38282 5.04737 1.45313Z" fill="#127127" />
                      </svg>
                      <span className={classes.toastText} style={{ color: '#3c763d', fontSize: '14px', fontWeight: 500, flex: 1 }}>
                        {customToastMessage}
                      </span>
                      <button
                        type="button"
                        onClick={handleCloseCustomToast}
                        style={{
                          background: 'none',
                          border: 'none',
                          cursor: 'pointer',
                          padding: '0',
                          color: '#3c763d',
                          fontSize: '16px',
                          fontWeight: 'bold',
                          lineHeight: '1'
                        }}
                      >
                        ×
                      </button>
                    </div>
                  )}
                  <IconButton onClick={openModal} className={classes.cartIconButton}>
                    <Badge badgeContent={cartCount} showZero>
                      <svg width="28" height="28" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13.8203 24.2148H27.4961C27.9531 24.2148 28.3516 23.8398 28.3516 23.3359C28.3516 22.832 27.9531 22.457 27.4961 22.457H14.0195C13.3516 22.457 12.9414 21.9883 12.8359 21.2734L12.6484 20.043H27.5195C29.2305 20.043 30.1094 18.9883 30.3555 17.3125L31.293 11.1133C31.3164 10.9609 31.3398 10.7734 31.3398 10.668C31.3398 10.1055 30.918 9.71875 30.2734 9.71875H11.1367L10.9141 8.23047C10.7969 7.32812 10.4688 6.87109 9.27344 6.87109H5.16016C4.69141 6.87109 4.29297 7.28125 4.29297 7.75C4.29297 8.23047 4.69141 8.64062 5.16016 8.64062H9.12109L10.9961 21.5078C11.2422 23.1719 12.1211 24.2148 13.8203 24.2148ZM29.3477 11.4883L28.5156 17.1016C28.4219 17.8281 28.0352 18.2734 27.3438 18.2734L12.3906 18.2852L11.3945 11.4883H29.3477ZM14.7461 29.9102C15.8008 29.9102 16.6445 29.0781 16.6445 28.0117C16.6445 26.957 15.8008 26.1133 14.7461 26.1133C13.6797 26.1133 12.8359 26.957 12.8359 28.0117C12.8359 29.0781 13.6797 29.9102 14.7461 29.9102ZM25.7031 29.9102C26.7695 29.9102 27.6133 29.0781 27.6133 28.0117C27.6133 26.957 26.7695 26.1133 25.7031 26.1133C24.6484 26.1133 23.793 26.957 23.793 28.0117C23.793 29.0781 24.6484 29.9102 25.7031 29.9102Z" fill="#12344E" />
                      </svg>
                    </Badge>
                  </IconButton>
                </Box>
              </Box>


            </Box>

            {/* Tab Content */}
            {activeTab === 0 && <PremiumBacklinksTable />}
            {activeTab === 1 && <OrdersInProcessTable />}
          </Box>
        </div>
      </div>

      {/* Success Snackbar */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={4000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={handleCloseSnackbar} severity="success" variant="filled">
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </>
  );
};

export default PremiumBacklink; 